"use client";

import React from "react";

import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useLearning } from "@/context/NutrafolAcademyContext";

export interface LearningProgressProps {
  isSidebar?: boolean;
}

const LearningProgress = ({ isSidebar = true }: LearningProgressProps) => {
  const { courses, completedSteps } = useLearning();

  const courseCount = courses.length;
  const coursesCompleted = completedSteps.length;

  return (
    <div className="p-4 rounded-sm bg-nova-transparency-white-10 border border-nova-transparency-white-10">
      {isSidebar ? (
        <div className="pb-4 mb-4 border-b border-nova-transparency-white-20">
          {courseCount !== coursesCompleted ? (
            <TextElementNova
              text="Learning Progress:"
              className="Caption-10-Dia-Uppercase text-nova-base-white"
            />
          ) : (
            <>
              <TextElementNova
                text="Your certification is complete."
                className="Body-30-Dia-Strong text-nova-base-white mb-2"
              />
              <TextElementNova
                text="You’re ready to share your Nutrafol story."
                className="text-nova-base-white"
                classes={{
                  default: "Body-10-Dia-Normal",
                  1024: "Body-20-Dia-Normal",
                }}
              />
            </>
          )}
        </div>
      ) : null}
      <div className="flex">
        <div className="flex gap-2 mr-2 lg:mr-4">
          {Array.from({ length: courseCount }).map((_, i) => (
            <div
              key={`course-progess-${i}`}
              className={`w-[10px] lg:w-4 h-[10px] lg:h-4 rounded-full ${
                i < coursesCompleted
                  ? "bg-nova-brand-accent-80"
                  : "border border-nova-transparency-white-40"
              }`}
            />
          ))}
        </div>
        <TextElementNova
          text={`${coursesCompleted} of ${courseCount} courses completed.`}
          className="text-nova-base-white !leading-[100%] !italic Caption-10-Dia-Normal lg:hidden"
        />
        <TextElementNova
          text={`${coursesCompleted} of ${courseCount} courses completed.`}
          className="text-nova-base-white !leading-[100%] !italic Body-20-Dia-Normal hidden lg:block"
        />
      </div>
    </div>
  );
};

export default LearningProgress;
